export const GET_PORTFOLIO_NFTS_FAILURE = 'GET_PORTFOLIO_NFTS_FAILURE';
export const GET_PORTFOLIO_NFTS_REQUEST = 'GET_PORTFOLIO_NFTS_REQUEST';
export const GET_PORTFOLIO_NFTS_SUCCESS = 'GET_PORTFOLIO_NFTS_SUCCESS';

export const GET_PORTFOLIO_NFTS_CHAMPIONS_FAILURE = 'GET_PORTFOLIO_NFTS_CHAMPIONS_FAILURE';
export const GET_PORTFOLIO_NFTS_CHAMPIONS_REQUEST = 'GET_PORTFOLIO_NFTS_CHAMPIONS_REQUEST';
export const GET_PORTFOLIO_NFTS_CHAMPIONS_SUCCESS = 'GET_PORTFOLIO_NFTS_CHAMPIONS_SUCCESS';

export const GET_PORTFOLIO_NFT_OWNED_FAILURE = 'GET_PORTFOLIO_NFT_OWNED_FAILURE';
export const GET_PORTFOLIO_NFT_OWNED_REQUEST = 'GET_PORTFOLIO_NFT_OWNED_REQUEST';
export const GET_PORTFOLIO_NFT_OWNED_SUCCESS = 'GET_PORTFOLIO_NFT_OWNED_SUCCESS';

export const GET_PORTFOLIO_NFT_STAKING_FAILURE = 'GET_PORTFOLIO_NFT_STAKING_FAILURE';
export const GET_PORTFOLIO_NFT_STAKING_REQUEST = 'GET_PORTFOLIO_NFT_STAKING_REQUEST';
export const GET_PORTFOLIO_NFT_STAKING_SUCCESS = 'GET_PORTFOLIO_NFT_STAKING_SUCCESS';

export const GET_PORTFOLIO_NFT_REQUEST = 'GET_PORTFOLIO_NFT_REQUEST';
export const GET_PORTFOLIO_NFT_SUCCESS = 'GET_PORTFOLIO_NFT_SUCCESS';
export const GET_PORTFOLIO_NFT_FAILURE = 'GET_PORTFOLIO_NFT_FAILURE';

export const GET_PORTFOLIO_NFT_STAKES_REQUEST = 'GET_PORTFOLIO_NFT_STAKES_REQUEST';
export const GET_PORTFOLIO_NFT_STAKES_SUCCESS = 'GET_PORTFOLIO_NFT_STAKES_SUCCESS';
export const GET_PORTFOLIO_NFT_STAKES_FAILURE = 'GET_PORTFOLIO_NFT_STAKES_FAILURE';

export const MINT_NFT_TICKET_REQUEST = 'MINT_NFT_TICKET_REQUEST';
export const MINT_NFT_TICKET_SUCCESS = 'MINT_NFT_TICKET_SUCCESS';
export const MINT_NFT_TICKET_FAILURE = 'MINT_NFT_TICKET_FAILURE';
export const CLEAR_MINT_NFT_TICKET_STATE = 'CLEAR_MINT_NFT_TICKET_STATE';
